<template>
  <BModal
    :active.sync="show"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    class="confirm-buy"
  >
    <div class="modal-card modal-confirm" style="width: auto">
      <section class="modal-card-body">
        <img class="icon" src="/images/correct.png" />
        <div class="title">Pago realizado</div>
      </section>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'SuccesPayment',
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    cancelModal() {
      this.$emit('onCancel');
    },
  },
  created() {},
};
</script>
<style>
@media screen and (max-width: 768px) {
  .buy .modal .animation-content {
    width: auto !important;
  }
}
</style>
<style lang="scss" scoped>
.icon {
  width: 80px;
  height: 80px;
}
.title {
  font-family: 'Avenir-Demi';
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.04;
  letter-spacing: -0.48px;
  text-align: center;
  margin-top: 30px;
  color: #132839;
}
.modal-card-body {
  padding: 20px 20px 20px 20px !important;
  // @media screen and (max-width: 400px) {
  //   padding: 20px 5px 0px 5px !important;
  // }
  // @media screen and (max-width: 380px) {
  //   padding: 1px 1px 0px 1px !important;
  // }
}
.modal-confirm {
  overflow: hidden;
  padding: 40px 52px;
  border-radius: 17px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
</style>
